
//import { VIDEO_HOST } from "@/api/api";

import Button from "primevue/button";
import router from "@/router";
import { useStore } from "@/store";
import { computed, defineComponent, onMounted, reactive, ref, Ref } from "vue";
import ChatRoom from "@/components/onlineCare/ChatRoom.vue";
import $API from "@/services";
import { useI18n } from "vue-i18n";
import { Clipboard } from "@/utils/Clipboard"

import { IAlert } from "@/models/common";
import { messageType } from "@/models/message";

export default defineComponent({
  name: "Online Care Video",
  props: {
    id: {
      type: String,
      required: true,
    },
    url: String,
    guest: String
  },
  setup(props) {
    const store = useStore();
    const userName = ref(''); 
    const roomId = ref<string>("");
    const { t, locale } = useI18n();
    const isGuestMode = ref(false);

    console.log(props.id, 'props.id');
    console.log(props.url, 'props.url');
    console.log(props.guest, 'props.guest');

    
    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

   
    roomId.value = props.id.toString();
    const style = reactive({
      width: "100%",
    });
    const iframe = reactive({
      src: "",
      style,
      wrapperStyle: null,
    });
    const isChat = computed(() => process.env.VUE_APP_ISCHAT === "true");
   
    const copyInviteLink = async () => {
      try {
        const chatUrl = await $API.VideoChatService.getGuestVideoChatUrl(props.id);
        try {
          console.log(chatUrl, '<=chatUrl');
          const result = await Clipboard.copyTextToClipboard(chatUrl);
          console.log(result, '<=copyTextToClipboard.result');
          if(result) {
            alert.value.type = messageType.INFO;
            alert.value.content = t('Copied to clipboard');
          } else {
            alert.value.type = messageType.ERROR;
            alert.value.content = t('Failed to copy to clipboard');
          }
        } catch(ex:any) {
          alert.value.type = messageType.ERROR;
          alert.value.content = ex;
        }
      } catch(ex:any) {
        alert.value.type = messageType.ERROR;
        alert.value.content = ex.Exception;
      }
    }

    onMounted(async () => {
      if(props.url && props.url.length>0) {
        isGuestMode.value = true;
      } else {
        userName.value = store.getters.getAccountInfo?.UserName || '';
      }

      window.addEventListener("message", (e: any) => {
        if (e.data.toString() === "exit") router.go(-1);
      });

      try {
        //console.log($API.VideoChatService, 'onMounted.$API.VideoChatService');
        let chatUrl = props.url || await $API.VideoChatService.getVideoChatUrl(props.id, userName.value || '');
        if(chatUrl && chatUrl.indexOf('lang') <=0) {
          chatUrl = chatUrl + '&lang=' + locale.value;
        }
        iframe.src = chatUrl;
      } catch(ex) {
        console.warn(ex, '<=exception');
      }

      //iframe.src = chatUrl; //`${VIDEO_HOST}/room/CASE_${props.id}?displayName=${userName.value}&token=${userToken.value}`;
      state.isLoading = false;
    });
    const state = reactive({ iframe, isLoading: true });

    const isGuest = computed(()=>{
      return props.guest === 'true';
    })

    return { state, roomId, userName, isChat, isGuest, t, copyInviteLink, alert };
  },
  components: { ChatRoom, Button },
});
